import { c as _c } from "react/compiler-runtime";
import { SelectGroupRole } from "@components/role/select-group-role";
import { MemberRoleReadOnly } from "@components/table/members/members-column/role-column/member-role-read-only";
import { useHasUserValidRoleGroupLevel } from "@hooks/access-control/use-has-user-valid-role-group-level";
import { useChangeMemberRole } from "@hooks/use-change-member-role";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { DEFAULT_TEXT_FONT_SIZE } from "@styles/common-styles";
import { formatUserRoleType } from "@utils/data-display";
/** Render and adjust member roles in group context */
export function GroupMemberRole(t0) {
  const $ = _c(20);
  const {
    companyId,
    memberIdentityRole,
    selectedGroup,
    isReadOnly: t1,
    location
  } = t0;
  const isReadOnly = t1 === undefined ? false : t1;
  const currentUser = useAppSelector(currentUserSelector);
  let t2;
  if ($[0] !== selectedGroup) {
    t2 = {
      selectedGroup
    };
    $[0] = selectedGroup;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    canEditMember
  } = useHasUserValidRoleGroupLevel(t2);
  let t3;
  if ($[2] !== companyId || $[3] !== location || $[4] !== memberIdentityRole.identity || $[5] !== memberIdentityRole.role || $[6] !== selectedGroup) {
    t3 = {
      companyId,
      location,
      subjectType: "group",
      memberIdentity: memberIdentityRole.identity,
      currentRole: memberIdentityRole.role,
      group: selectedGroup
    };
    $[2] = companyId;
    $[3] = location;
    $[4] = memberIdentityRole.identity;
    $[5] = memberIdentityRole.role;
    $[6] = selectedGroup;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    changeMemberRole
  } = useChangeMemberRole(t3);
  const isCurrentUser = currentUser?.identity === memberIdentityRole.identity;
  const isCurrentUserGM = currentUser?.role === "COMPANY_MANAGER";
  if (isReadOnly) {
    let t4;
    if ($[8] !== memberIdentityRole.role) {
      t4 = <MemberRoleReadOnly role={memberIdentityRole.role} variant="borderless" />;
      $[8] = memberIdentityRole.role;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (isCurrentUser && isCurrentUserGM || !canEditMember) {
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        fontSize: DEFAULT_TEXT_FONT_SIZE
      };
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== memberIdentityRole.role) {
      t5 = formatUserRoleType(memberIdentityRole.role);
      $[11] = memberIdentityRole.role;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== t5) {
      t6 = <span style={t4}>{t5}</span>;
      $[13] = t5;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    return t6;
  }
  let t4;
  if ($[15] !== changeMemberRole) {
    t4 = async function onRoleChange(role) {
      try {
        await changeMemberRole(role);
      } catch {}
    };
    $[15] = changeMemberRole;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const onRoleChange = t4;
  const t5 = memberIdentityRole.role;
  let t6;
  if ($[17] !== onRoleChange || $[18] !== t5) {
    t6 = <SelectGroupRole selectedRole={t5} onChange={onRoleChange} variant="borderless" />;
    $[17] = onRoleChange;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}